import React, { useState, useEffect, useRef, useCallback } from 'react';
import UrlScanSummaryHeader from './UrlScanSummaryHeader'
import Card from 'react-bootstrap/Card';
import UrlList from './UrlList'
import CollapsibleCard from '../common/CollapsibleCard'
import { submitUrlsForScanning } from '../../../helpers/urlscan'
import { getHtmlBodyAsync } from '../../../helpers/mailbox'
import { parseWebPageLinksFromHtml, fetchCompletedUrlScanResults } from '../../../helpers/urlscan'
import { getUserProfile } from "../../../helpers/mailbox"
import { isPaiedUser, contactDtonomy } from "../../../helpers/get_permission"

function getIncompleteScanLinks(links, completedScans) {
    return links.filter(link => !completedScans.map(cs => cs.url).includes(link.href));
}

function getMaliciousUrlCount(completedScans) {
    return completedScans.filter(cs => cs.verdicts && cs.verdicts.overall && cs.verdicts.overall.malicious).length;
}

function getCompletedUrlCount(links, completedScans) {
    return links.filter(link => completedScans.map(cs => cs.url).includes(link.href)).length;
}

export default function UrlScanCard() {
    const [links, setLinks] = useState([]);
    const [payment, setPayment] = useState(false);
    const [completedScans, setCompletedScans] = useState([]);
    const pollInterval = 5000; // 5 sec interval
    const maxPollingRetry = 30;// 30 is 2.5 minutes when 5 sec interval
    const pollCountRemainingRef = useRef(maxPollingRetry); // Ref is used so that we can decrement without re-render

    useEffect(() => {
        let userEmail = getUserProfile().emailAddress;
        isPaiedUser(userEmail).then(
            paid => {
                if (paid) {
                    console.log("this is a vip user: " + userEmail)
                    setPayment(true)
                } else {
                    console.log("this is a free user " + userEmail)
                }
            }
        )
        // Get the html string from the email message body
        getHtmlBodyAsync().then((htmlBody) => {
            // Extract the web page hyperlinks
            setLinks(parseWebPageLinksFromHtml(htmlBody));
        });
    }, []);

    useEffect(() => {
        if (links.length > 0) {
            submitUrlsForScanning(links.map(link => link.href)).then((data) => {
                startPollingForCompletedResults();
            }).catch((e) => {
                console.log(e);
            })
        }
    }, [links, completedScans]);

    const startPollingForCompletedResults = useCallback(() => {
        const incompleteScanUrls = getIncompleteScanLinks(links, completedScans).map(link => link.href);
        if (pollCountRemainingRef.current-- > 0 && incompleteScanUrls.length > 0) {
            fetchCompletedUrlScanResults(incompleteScanUrls).then(completedScansObj => {
                const newCompletedScans = Object.values(completedScansObj);
                if (newCompletedScans && newCompletedScans.length > 0) {
                    // // Reset pollingCountRemaining
                    pollCountRemainingRef.current = maxPollingRetry;
                    // setCompletedScans will trigger a call to the above effect with completedScans as a dependency, then re-render, 
                    // then call startPollingForCompletedResults again via the effect
                    setCompletedScans((prev) => [...prev, ...newCompletedScans]);
                }
                else {
                    // Recursively call startPollingForCompletedResults, when there is nothing to re-render
                    // but when there may still be incompleteScan results pending

                    // Recursive timeout will initiate next polling request
                    setTimeout(startPollingForCompletedResults, pollInterval);
                }
            }).catch((e) => {
                console.log(e);
            })
        }
    }, [links, completedScans]);

    if (!payment) {
        return (
            <CollapsibleCard header="URLs" ctrlName="urlScanResult" isOpen={true}>
                 <Card.Header>
                    <UrlScanSummaryHeader
                        completedUrlCount={getCompletedUrlCount(links, completedScans)}
                        maliciousUrlCount={getMaliciousUrlCount(completedScans)}
                        totalUrlCount={links.length}
                    />
                </Card.Header>
                {links.length > 0 &&  completedScans.length > 0 && <UrlList links={[links[0]]} completedScans={[completedScans[0]]} />}
                <div className="overlay" onClick={contactDtonomy}>
                    <small className="font-weight-bold">Subscribe to <a href="" target="_blank" rel="noreferrer">Phish AIR Professional</a> to scan more suspicious URLs for only $0.99/month!</small>
                </div>
                <p className="blur">
                    Once unlocked. the following will show the scan result of the urls that the email contains.
                </p>
            </CollapsibleCard>
        );
    } else {
        return (
            <CollapsibleCard header="URLs" ctrlName="urlScanResult" isOpen={true}>
                <Card.Header>
                    <UrlScanSummaryHeader
                        completedUrlCount={getCompletedUrlCount(links, completedScans)}
                        maliciousUrlCount={getMaliciousUrlCount(completedScans)}
                        totalUrlCount={links.length}
                    />
                </Card.Header>
                <UrlList links={links} completedScans={completedScans} />
            </CollapsibleCard>
        );
    }
}